import { setLightness } from 'polished';
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import twitterIcon from "../content/img/icon-twitter.png";

import { colors } from '../styles/colors';
import { outer, inner } from '../styles/shared';
import config from '../website-config';

export const Footer: React.FC = () => {
  return (
    <footer css={[outer, SiteFooter]}>
      <div css={[inner, SiteFooterContent]}>
        <p css={[SiteFooterText]}>
          <b>
            Pour être au courant des nouvelles publications, vous pouvez
            vous abonner au flux <a css={[SiteFooterLink]} href="/rss.xml">rss</a>, ou suivre le
            compte <a css={[SiteFooterLink]} href={config.twitter} target="_blank" rel="noopener noreferrer">twitter</a>.
          </b>
          &nbsp; Ce site a été réalisé par <a css={[SiteFooterLinkSecondary]} href="https://smknstd.github.io" target="_blank" rel="noopener noreferrer">Arnaud Becher</a> avec
          &nbsp;<a css={[SiteFooterLinkSecondary]} href="https://www.gatsbyjs.org/" target="_blank" rel="noopener noreferrer">GatsbyJs</a>. Il est hébergé gratuitement par <a css={[SiteFooterLinkSecondary]} href="https://www.netlify.com/" target="_blank" rel="noopener noreferrer">Netlify</a>.
          Il n'utilise aucun cookie. Des statistiques anonymes sont collectées avec <a css={[SiteFooterLinkSecondary]} href="https://www.cloudflare.com/web-analytics/" target="_blank" rel="noopener noreferrer">Cloudflare web analytics</a>.
        </p>
        <SiteFooterNav>
          {config.twitter && (
            <a href={config.twitter} target="_blank" rel="noopener noreferrer">
             <img src={twitterIcon} alt='twitter icon'/>
            </a>
          )}
        </SiteFooterNav>
      </div>
    </footer>
  );
};

const SiteFooter = css`
  position: relative;
  padding: 0px 25vw;
  padding-top: 130px;
  padding-bottom: 130px;
  color: #fff;
  background: ${setLightness('0.0015', colors.darkgrey)};
`;

const SiteFooterContent = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.3rem;
  a {
    color: rgba(255, 255, 255, 0.7);
  }
  a:hover {
    color: rgba(255, 255, 255, 1);
    text-decoration: none;
  }
  @media (max-width: 650px) {
    flex-direction: column;
  }
`;

const SiteFooterText = css`
  max-width: 500px;
  font-size: 150%;
`;

const SiteFooterLink = css`
  color: red !important;
`;

const SiteFooterLinkSecondary = css`
  color: white !important;
`;

const SiteFooterNav = styled.nav`
  display: flex;

  a {
    position: relative;
    margin-left: 20px;
  }

  a:before {
    content: '';
    position: absolute;
    top: 11px;
    left: -11px;
    display: block;
    width: 2px;
    height: 2px;
    background: #fff;
    border-radius: 100%;
  }

  a:first-of-type:before {
    display: none;
  }
  @media (max-width: 650px) {
    a:first-of-type {
      margin-left: 0;
    }
  }
`;

